import { selectComponentState } from 'projectRedux/store';
import { ductAdapterAdapter } from '../adapters/ductAdapterAdapter';

export const {
  selectAll: selectAllDuctAdapters,
  selectById: selectDuctAdapterById,
  selectEntities: selectDuctAdapterEntities,
} = ductAdapterAdapter.getSelectors((state) => selectComponentState(state).ductadapters);
